import type { FaireAdPerformancePeriodEntity } from "../../entity_types/adPerformancePeriod";

export const perfP6ChurnedReorder202602: FaireAdPerformancePeriodEntity = {
  token: "perf_p6_churned_reorder_202602",
  type: "adPerformancePeriod",
  scope: "REORDER_MARKETPLACE",
  periodType: "RECEIPT",
  startDate: "2026-02-01",
  endDate: "2026-02-28",
  impressions: 5675,
  clicks: 80,
  adsSpendDollars: 176,
  budgetDollars: 600,
  salesDollars: 1800,
  bestEstimateRoas: 10.23,
  bestEstimateType: "ACTUALIZED",
  budgetUtilization: 0.29,
  reorderConversions: 5,
  dataAvailableAtDate: "2026-03-04",
  meta: {
    source: "mock",
    importedAt: "2026-07-06T00:00:00.000Z",
    importedBy: "advertiser-profiles",
  },
};
